// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useBurnRequests2Step } from '@hooks/queries/registry/burn/useBurnRequests2Step';
import useRegistrarService from '@hooks/queries/registry/onboarding/useRegistrarService';
import { BurnRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Burn';
import { useParties } from '../../contexts/PartiesContext';
import TemplateContract from '../../utils/TemplateContract';

export const useInboundBurnRequests = () => {
  const registrarService = useRegistrarService();
  const isRegistrar = !!registrarService.data;
  const { party } = useParties();
  const transform = (data: TemplateContract<BurnRequest>[]) => {
    if (isRegistrar) {
      return 0;
    }
    return data.filter((request) => request.payload.burn.instrumentId.admin === party).length;
  };
  return useBurnRequests2Step(transform);
};
